import { PageHeader, Tag, Space } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { TableItemDinamico, dineroDisabledMask, ButtonItem, TourItem } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const TIPOS_MOVIMIENTO = {
  801: { label: "Alta de Activo Fijo", color: "green" },
  802: { label: "Depreciación de Activo Fijo", color: "blue" },
  803: { label: "Venta de Activo Fijo", color: "purple" },
  804: { label: "Baja de Activo Fijo", color: "red" },
};

class MovimientosActivos extends Component {
  refTabla = React.createRef();
  state = {
    loading: false,
    openTour: false,
    todosMovimientos: [],
    totalRecords: 0,
  };

  consultarMovimientos(params) {
    this.setState({ loading: true });
    axios
      .post(
        "activosFijos/selectMovimientosActivosFijos",
        { empresaId: this.props.empresaId, ...params, limit: params.pageSize },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ todosMovimientos: res.data.data || [], totalRecords: res.data.totalRecords || 0 });
        } else {
          this.setState({ todosMovimientos: [], totalRecords: 0 });
        }
      })
      .catch(() => this.setState({ todosMovimientos: [] }))
      .finally(() => this.setState({ loading: false }));
  }

  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "serieNumero",
        key: "serieNumero",
        width: "12%",
      },
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        render: (value) => (value ? moment(value).format("DD/MM/YYYY HH:mm") : "-"),
        width: "15%",
      },
      {
        title: "Tipo",
        dataIndex: "tipoMovimiento",
        key: "tipoMovimiento",
        render: (value) => {
          const config = TIPOS_MOVIMIENTO[value] || { label: "—", color: "default" };
          return <Tag color={config.color} className="square-tag">{config.label}</Tag>;
        },
        width: "18%",
      },
      {
        title: "Documento Origen",
        dataIndex: "documentoOrigenTipo",
        key: "documentoOrigenTipo",
        width: "18%",
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        key: "concepto",
        width: "22%",
      },
      {
        title: "Monto",
        dataIndex: "costoTotal",
        key: "costoTotal",
        render: (value) => dineroDisabledMask(value),
        width: "10%",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        render: (value) => value === 1
          ? <Tag color="green" className="square-tag">Activo</Tag>
          : <Tag color="default" className="square-tag">Cancelado</Tag>,
        width: "10%",
      },
    ];
    return (
      <>
        <PageHeader
          title="Movimientos de Activos Fijos"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={
            <Space>
              <ButtonItem type="default" blanco onClick={() => this.setState({ openTour: true })}>
                ¿Cómo funciona?
              </ButtonItem>
            </Space>
          }
        />
        <div ref={this.refTabla}>
          <TableItemDinamico
            onFetchData={this.consultarMovimientos.bind(this)}
            totalRecords={this.state.totalRecords}
            dataSource={this.state.todosMovimientos || []}
            loading={this.state.loading}
            columns={columns}
            size="small"
            pagination={false}
            setTextoFiltro={(textoFiltro) => this.setState({ textoFiltro })}
            valorTextoDefault={""}
            filterStorageKey={"movimientosActivosFiltrosTabla" + this.props.empresaId}
          />
        </div>
        <TourItem
          open={this.state.openTour}
          onClose={() => this.setState({ openTour: false })}
          steps={[
            {
              title: "Movimientos de Activos Fijos",
              description: "Kardex global de todo lo que pasa con tus activos fijos: altas, depreciaciones, ventas y bajas, cada una con su folio propio y su póliza contable asociada.",
              target: null,
            },
            {
              title: "Tipos de movimiento",
              description: "Alta (cuando das de alta una unidad física), Depreciación (cada corrida periódica), Venta y Baja (cuando la unidad sale del inventario).",
              target: () => this.refTabla.current,
            },
          ]}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(MovimientosActivos);
